// src/components/Dashboard/BalanceCard.js
import { Card, CardContent, Typography } from '@mui/material';

function BalanceCard({ balance }) {
  return (
    <Card
      sx={{
        boxShadow: '0 4px 15px rgba(255, 0, 0, 0.2)',
        borderRadius: '12px',
        p: 2
      }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Kullanıcı Bakiyesi
        </Typography>
        <Typography variant="h5">{balance}₺</Typography>
      </CardContent>
    </Card>
  );
}

export default BalanceCard;
